import { render, staticRenderFns } from "./FreeTier.vue?vue&type=template&id=28d262b5&scoped=true&"
import script from "./FreeTier.vue?vue&type=script&lang=js&"
export * from "./FreeTier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d262b5",
  null
  
)

export default component.exports